module.exports = __webpack_public_path__ + "static/media/Legacy_logo.4665e537.svg";